/**
 * 直播间相关接口
 */

import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const productOperation = {
	/**
	 * 根据关键字搜索学校列表
	 */
	getShoolListByKeyword(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school/school-list`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 根据关键字搜索代理商列表
	 */
	getAgentListByKeywod(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/agent/agent-list`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 获取会员学校列表
	 */
	getShoolList(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/course/school-list`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 切换会员
	 */
	switchMembership(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/course/operation-switch`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 直播间免费课程列表
	 */
	getFreeCourseList(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/course/live-free-course-list`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 直播间付费课程列表
	 */
	getChargeCourseList(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/course/live-charge-course-list`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 根据id删除免费课程
	 */
	removeFreeCourseById(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/course/live-free-course-delete`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 根据id删除付费课程
	 */
	removeChargeCourseById(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/course/live-charge-course-delete`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 创建免费课程
	 */
	createFreeCourse(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/course/live-free-course-create`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 创建付费课程
	 */
	createChargeCourse(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/course/live-charge-course-create`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 设置免费课程状态
	 */
	setFreeCourseStatus(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/course/live-free-course-set-status`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 设置付费课程状态
	 */
	setChargeCourseStatus(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/course/live-charge-course-set-status`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 更新免费课程
	 */
	updateFreeCourse(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/course/live-free-course-update`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 更新付费课程
	 */
	updateChargeCourse(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/course/live-charge-course-update`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 学校数据导出 - 开始
	/**
	 * 选择省
	 */
	getChooseProvince(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/SchoolExportExcel/province`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 选择市
	 */
	getChooseCity(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/SchoolExportExcel/city`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 选择区
	 */
	getChooseArea(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/SchoolExportExcel/area`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 选择学校性质 学校类型 运营状态
	 */
	getChooseCommon(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/SchoolExportExcel/common`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 选择代理商
	 */
	getChooseManager(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/SchoolExportExcel/manager`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 学校数据导出
	 */
	getChooseInfo(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/SchoolExportExcel/info`,
			headers: config.headers,
			params
		});
	}
};

export default productOperation;
